import { del, get, patch, post } from './http.ts';
import type { ShareLink } from './types.ts';

export interface CreateLinkInput {
  namespace_id: string;
  path: string;
  password?: string;
  expires_at?: string;
  allow_download: boolean;
  allow_upload: boolean;
  max_downloads?: number;
}

export const createLink = (
  input: CreateLinkInput,
): Promise<{ id: string; token: string; url: string }> => post('/share/links', input);

export const listLinks = (): Promise<{ items: ShareLink[] }> => get('/share/links');

export const updateLink = (
  id: string,
  patchBody: { password?: string | null; allow_download?: boolean;
               expires_at?: string | null; max_downloads?: number | null },
): Promise<{ ok: boolean }> => patch(`/share/links/${id}`, patchBody);

export const revokeLink = (id: string): Promise<{ ok: boolean }> => del(`/share/links/${id}`);

// ── 공유 폴더 ──

export interface SharedFolder {
  namespace_id: string;
  name: string;
  role: 'owner' | 'editor' | 'viewer';
  owner: { id: string; name: string };
  member_count: number;
  file_count: number;
  total_size: number;
  is_owner: boolean;
}

export interface ShareMember {
  user_id: string;
  email: string;
  name: string;
  role: 'owner' | 'editor' | 'viewer';
  joined_at: string;
}

export const shareFolder = (
  namespaceId: string, path: string,
  members: Array<{ email: string; role: 'editor' | 'viewer' }>,
): Promise<{ namespace_id: string; name: string; members: number; invited: string[] }> =>
  post('/share/folders', { namespace_id: namespaceId, path, members });

export const listSharedFolders = (): Promise<{ items: SharedFolder[] }> =>
  get('/share/folders');

export const listShareMembers = (nsId: string): Promise<{ items: ShareMember[] }> =>
  get(`/share/folders/${nsId}/members`);

export const addShareMembers = (
  nsId: string, members: Array<{ email: string; role: 'editor' | 'viewer' }>,
): Promise<{ invited: string[] }> => post(`/share/folders/${nsId}/members`, { members });

export const setMemberRole = (
  nsId: string, userId: string, role: 'editor' | 'viewer',
): Promise<{ ok: boolean }> => patch(`/share/folders/${nsId}/members/${userId}`, { role });

export const removeShareMember = (nsId: string, userId: string): Promise<{ ok: boolean }> =>
  del(`/share/folders/${nsId}/members/${userId}`);

export const leaveShare = (nsId: string): Promise<{ ok: boolean }> =>
  post(`/share/folders/${nsId}/leave`);

export const unshareFolder = (nsId: string): Promise<{ path: string }> =>
  post(`/share/folders/${nsId}/unshare`, {});
